import Client1 from "../Assets/sales1.png";
import Client2 from "../Assets/sales2.png";
import Client3 from "../Assets/sales3.png";
import Client4 from "../Assets/sales4.png";
import Client5 from "../Assets/sales5.png";

export const images = [Client1, Client2, Client3, Client4, Client5];
